  /**
  * @description: 组件间消息通信
  * @author: longzhiyong
  * @createTime: longzhiyong(2019-07-26)
  * @updateTime: name(xxxx-xx-xx)
  */
import Vue from 'vue'

export let bus = new Vue()



// WEBPACK FOOTER //
// ./src/bus.js